import type { RouteLocation } from "vue-router";
import { defineNuxtRouteMiddleware } from "#app";
import { navigateTo, useCookie, $contentDeliveryResource, $apiFetch } from "#imports";

/**
 * A global middleware that will check if the route
 * looks like the Umbraco preview routes, e.g. "/1023"
 * and the UMB_UCONTEXT cookie is set.
 *
 * If both conditions are true,
 * look up that content and redirect to its actual URL.
 *
 * The main point of this is to catch any content pages
 * that are implemented as Nuxt /pages, not our bespoke /templates
 * folder.
 * @param to The route we're going to
 */

export default defineNuxtRouteMiddleware( async ( to: RouteLocation ) => {
  const id = parseInt( to.path.replace( "/", "" ), 10 );
  const cookie = useCookie( "UMB_UCONTEXT" );

  if ( id > 0 && cookie.value ) {
    const previewCookie = useCookie( "UMB_PREVIEW" );
    if ( !previewCookie.value ) {
      console.warn( "No preview cookie found, creating..." );
      previewCookie.value = "preview";
    }

    let key = await $apiFetch<string | null>( `/umbraco/backoffice/api/PreviewMode/ContentKeyLookup?id=${id}` );

    if ( key ) {
      key = key.replace( ")]}',\n", "" );
      key = key.replaceAll( "\"", "" );

      const contentResource = $contentDeliveryResource();
      const content = await contentResource.getById( key );

      if ( content ) {
        return navigateTo( content.route.path, {
          external: true, // force a full page load
        } );
      } else {
        throw new Error( `Unable to find content with key: ${key}` );
      }
    } else {
      throw new Error( `Unable to find key for content with id: ${id}` );
    }
  }
} );
